export enum TextIconColor {
  BLACK = 'BLACK',
  CLEAR_MEDIUM = 'CLEAR_MEDIUM',
  DESTRUCTIVE = 'DESTRUCTIVE',
  DISABLED = 'DISABLED',
  ERROR = 'ERROR',
  GRAY = 'GRAY',
  HIGHLIGHT = 'HIGHLIGHT',
  PRIMARY = 'PRIMARY',
  PRIMARY_HIGHLIGHT = 'PRIMARY_HIGHLIGHT',
  SECONDARY = 'SECONDARY',
  SECONDARY_HIGHLIGHT = 'SECONDARY_HIGHLIGHT',
  WARNING = 'WARNING'
}

/**
 * Plain Tailwind class strings for text/icon colors
 * Use this with tailwind-variants or anywhere needing string classes
 */
export const TEXT_COLOR_CLASSES: Record<TextIconColor, string> = {
  [TextIconColor.BLACK]: 'text-black-raisin',
  [TextIconColor.DESTRUCTIVE]: 'text-fuchsia-destructive',
  [TextIconColor.DISABLED]: 'text-white/50',
  [TextIconColor.ERROR]: 'text-fuchsia-error',
  [TextIconColor.HIGHLIGHT]: 'text-highlight',
  [TextIconColor.PRIMARY]: 'text-white',
  [TextIconColor.PRIMARY_HIGHLIGHT]: 'text-primary-highlight',
  [TextIconColor.SECONDARY]: 'text-primary-dull',
  [TextIconColor.SECONDARY_HIGHLIGHT]: 'text-markdown-periwinkle',
  [TextIconColor.GRAY]: 'text-gray',
  [TextIconColor.WARNING]: 'text-yellow-warning',
  [TextIconColor.CLEAR_MEDIUM]: 'text-white/30'
};
